import { Controls } from 'jsx/components/core/form/components/FormBuilder';

export type auditKeys =
  | 'id'
  | 'audit_type_id'
  | 'property_id'
  | 'submitted'
  | 'submit_date'
  | 'createdby'
  | 'created'
  | 'updatedby'
  | 'updated'
  | 'id';

export const auditsForm: Controls<auditKeys> = {
  audit_type_id: {
    name: 'audit_type_id',
    path: 'audit_type_id',
    caption: 'Audit Type',
    value: '',
    type: 'select',
    validationRules: { required: 'Audit type is required' },
    options: [],
  },
  id: {
    name: 'id',
    path: 'id',
    value: '',
    type: 'hidden',
    validationRules: {},
  },
  property_id: {
    name: 'property_id',
    path: 'property_id',
    value: '',
    type: 'hidden',
    validationRules: {},
  },
  submitted: {
    name: 'submitted',
    path: 'submitted',
    caption: 'Is Submitted?',
    type: 'switch',
    switchLabel: { enabled: 'Yes', disabled: 'No' },
    value: false,
    validationRules: {
      required: 'Submitted is required',
    },
  },
  submit_date: {
    name: 'submit_date',
    path: 'submit_date',
    caption: 'Submitted Date',
    value: '',
    type: 'date',
    validationRules: {},
  },
  createdby: {
    name: 'createdby',
    path: 'createdby.name',
    caption: 'Created By',
    value: '',
    type: 'text',
    validationRules: {},
    modal: {
      show: false,
    },
  },
  created: {
    name: 'createdBy_date',
    path: 'created',
    caption: 'Created',
    value: '',
    type: 'date',
    validationRules: {},
    modal: {
      show: false,
    },
  },
  updatedby: {
    name: 'updatedby',
    path: 'updatedby.name',
    caption: 'Updated By',
    value: '',
    type: 'text',
    validationRules: {},
    modal: {
      show: false,
    },
  },
  updated: {
    name: 'updated',
    path: 'updated',
    caption: 'Updated',
    value: '',
    type: 'date',
    validationRules: {},
    modal: {
      show: false,
    },
  },
};
